import { DividerProps } from '@mui/material';
import { FC } from 'react';

import DividerWrapper from '../../wrappers/DividerWrapper';

export interface IAtomDividerProps extends DividerProps {
  thickness?: number;
  spacing?: number;
}

const AtomDivider: FC<IAtomDividerProps> = ({ thickness, spacing, orientation = 'horizontal', sx, ...props }) => {
  const thicknessStyles = thickness
    ? {
        borderBottomWidth: orientation === 'horizontal' ? thickness : undefined,
        borderRightWidth: orientation === 'vertical' ? thickness : undefined,
      }
    : {};

  const getSpacingStyles = (): Record<string, number> => {
    if (!spacing) {
      return {};
    }

    if (orientation === 'horizontal') {
      return { marginTop: spacing, marginBottom: spacing };
    }

    return { marginLeft: spacing, marginRight: spacing };
  };

  const spacingStyles = getSpacingStyles();

  const baseStyles = {
    ...thicknessStyles,
    ...spacingStyles,
  };

  return (
    <DividerWrapper
      data-testid="atom-divider"
      data-cy="atom-divider"
      orientation={orientation}
      sx={[baseStyles, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  );
};

export default AtomDivider;
